const PropsInitialState = {
  isFetching: false,
  didInvalidate: false,
  items: []
};

function DataDefaultReducer(pKind) {
  return (state = PropsInitialState, action) => {
    switch (action.type) {
      case `REQUEST_${pKind}`: {
        return {
          isFetching: true,
          didInvalidate: false,
          items: []
        }
      }
      case `RECEIVE_${pKind}`: {
        return {
          isFetching: true,
          didInvalidate: false,
          items: action.items
        }
      }
      default: {
        return state;
      }
    }
  }
}

export {
  DataDefaultReducer
};


// WEBPACK FOOTER //
// ./src/reducers/DataDefaultReducer.js